module.exports = __webpack_public_path__ + "img/loginChargerSuccess.2b0dd904.svg";